import './Components/GlobalJQuery'

// Import Twitter Bootstrap v4
//import 'bootstrap'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/tooltip'
import 'bootstrap/js/dist/popover'
import 'bootstrap/js/dist/alert'

// Import webfont Heebo
import 'typeface-heebo'

// Import lazysizes
import 'lazysizes'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
import 'lazysizes/plugins/bgset/ls.bgset'

// Import and initialize medium-zoom
//import mediumZoom from 'medium-zoom'
//mediumZoom('[data-action="zoom"]')

// Import components
import './Components/SlickCarousel'
import './Components/SmoothScroll'
import './Components/Tooltip'

// Import other packages
import '../../../../BF.Consent/Resources/Private/JavaScript/Consent'
import '../../../../BF.Office/Resources/Private/JavaScript/Office'

// Styles
import '../Styles/App.scss'
